import React from 'react';
import { Home as HomeIcon, Zap, Trophy, Target } from 'lucide-react';
import { RacingGame } from '../components/RacingGame';

export const Home = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center mb-6">
        <HomeIcon className="mr-2" size={32} />
        <h1 className="text-4xl font-bold">React Racing Game</h1>
      </div>

      <p className="text-lg text-gray-700 mb-8">
        Welcome to the ultimate React racing experience! Test your reflexes and compete against the computer in this exciting button-mashing race game.
      </p>

      {/* Racing Game Component */}
      <div className="mb-8">
        <RacingGame />
      </div>

      {/* Game Features */}
      <div className="bg-blue-50 p-6 rounded-md mb-8">
        <h2 className="text-xl font-semibold mb-4 flex items-center">
          <Zap className="mr-2" size={20} />
          Game Features:
        </h2>
        <ul className="space-y-2 pl-5">
          <li className="flex items-start">
            <span className="text-green-500 mr-2">🏎️</span>
            Fast-paced racing action
          </li>
          <li className="flex items-start">
            <span className="text-green-500 mr-2">🤖</span>
            AI-powered computer opponent
          </li>
          <li className="flex items-start">
            <span className="text-green-500 mr-2">⌨️</span>
            Keyboard controls (SPACE key)
          </li>
          <li className="flex items-start">
            <span className="text-green-500 mr-2">🏆</span>
            Score tracking system
          </li>
          <li className="flex items-start">
            <span className="text-green-500 mr-2">🎮</span>
            Instant replay capability
          </li>
        </ul>
      </div>

      {/* Tech Stack */}
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
        <div className="p-6">
          <h3 className="text-xl font-semibold mb-4 flex items-center">
            <Target className="mr-2" size={20} />
            Built With Modern Tech:
          </h3>
          <ul className="space-y-2 pl-5">
            <li className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              React with Hooks for state management
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              Tailwind CSS for responsive styling
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              Lucide icons for beautiful UI elements
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              Real-time animation and smooth transitions
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              Keyboard event handling
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
